export default __webpack_public_path__ + "static/media/forms.164f15db.jpg";